import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-voice-player',
  templateUrl: './voice-player.component.html',
  styleUrls: ['./voice-player.component.scss'],
})
export class VoicePlayerComponent {

  @ViewChild('audioPlayer')
  audioPlayer!: ElementRef<HTMLAudioElement>;
  
  ngAfterViewInit() {
    const audio = this.audioPlayer.nativeElement;
  
    audio.addEventListener('durationchange', () => {
      this.updateTimeDisplay();
    });
  }

  @ViewChild('progressBar')
  progressBar!: ElementRef<HTMLElement>;

  @Input() titleVoice: string = '';

  @Input() descVoice: string = '';

  @Input() audioSource: string = '';

  progressBarValue = 0;

  currentTime = '00:00';

  duration = '00:00';

  Pause_Play = false;

  speedNum = 1;

  playAudio() {

    const audio = this.audioPlayer.nativeElement;

    if (audio.paused) {

      audio.play();

      this.Pause_Play = true;

    } else {

      audio.pause();

      this.Pause_Play = false;

    }

  }

  changeSpeed(): void {

    const audio = this.audioPlayer.nativeElement;

    if (this.speedNum === 1) {

      this.speedNum = 2;
      audio.playbackRate = 1.5;

    } else if (this.speedNum === 2) {

      this.speedNum = 3;
      audio.playbackRate = 2;

    } else {

      this.speedNum = 1;
      audio.playbackRate = 1;

    }

  }

  startSeek(event: MouseEvent) {

    const audio = this.audioPlayer.nativeElement;
    const bar = this.progressBar.nativeElement;
  
    if (!isFinite(audio.duration) || audio.duration <= 0) return;
  
    const rect = bar.getBoundingClientRect();
  
    // 🔥 FIX FIREFOX SAFE POINT
    const clickX = event.offsetX ?? (event.clientX - rect.left);
  
    const percent = clickX / rect.width;
  
    const safePercent = Math.max(0, Math.min(1, percent));
  
    const newTime = safePercent * audio.duration;
  
    if (Number.isFinite(newTime)) {
      audio.currentTime = newTime;
    }
  
    this.updateTimeDisplay();
  }

  updateTimeDisplay() {

    const audio = this.audioPlayer.nativeElement;

    if (!audio.duration || isNaN(audio.duration))
      return;

    this.currentTime =
      this.formatTime(audio.currentTime);

    this.duration =
      this.formatTime(audio.duration);

    this.progressBarValue =
      (audio.currentTime / audio.duration) * 100;

    if (audio.ended) {

      this.Pause_Play = false;

    }

  }

  formatTime(time: number): string {

    const m = Math.floor(time / 60);

    const s = Math.floor(time % 60);

    return `${m.toString().padStart(2, '0')}:${s
      .toString()
      .padStart(2, '0')}`;

  }

}